// extracted by mini-css-extract-plugin
export default {"container":"Award_container__+glXo","grey":"Award_grey__p9RFW"};